import CourseIcon from 'img/icons/offering_icons/course_icon.svg';
import {
  BodyRowType,
  HeaderIconConfig,
  IconLabel,
  IconType,
  OfferingTypeConfig,
} from '../utils/types';

export const courseIconConfig: HeaderIconConfig = {
  backgroundColor: '#50A3B0',
  color: '#000',
  iconTitle: 'Delivery format: Course',
  src: CourseIcon,
};

const courseConfig: OfferingTypeConfig = {
  actionButtons: ({ displayProgress, entry, hasProgress, catalogStore, t }) => {
    const link = catalogStore.getCatalogEntryLink(entry, { hasProgress });
    if (!link) {
      return {};
    }

    return {
      actionButtonA: {
        buttonLabel: displayProgress ? t('Continue') : t('View'),
        href: link.href,
        icon: IconType.Arrow,
        onClick: link.navigate,
      },
    };
  },
  bodyRowsLayout: () => [BodyRowType.Icons],
  headerConfig: ({ t }) => ({
    iconB: courseIconConfig,
    title: t('Course'),
  }),
  iconRowsLayout: () => [[IconLabel.Duration, IconLabel.Level]],
};

export default courseConfig;
